import { ReactNode } from 'react';

interface ColorProps {
  /**
   * The hex code of the color.
   */
  color: string;
}

/**
 * A component that displays a circle with a color.
 * @param {props.color} The hex code of the color.
 * @returns {ReactNode} The color icon.
 */
export default function ColorIcon({ color }: ColorProps): ReactNode {
  return (
    <svg width="40" height="40" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="15" fill={color} />
      <path
        d="M32.9885 15.3865C32.0711 9.42019 28.0855 3.46971 22.4391 1.03901C15.227 -2.08618 6.41741 2.25436 2.4792 8.52051C-1.45901 14.7867 -0.747282 23.594 4.91488 28.5186C10.577 33.4431 19.3075 32.8591 25.2228 28.5501C28.4809 26.1826 30.8691 22.7101 31.8339 18.7958C32.941 14.2816 31.7864 9.76743 29.4773 5.82149C28.9712 4.9376 27.5952 5.74257 28.1171 6.61068C29.9992 9.81478 31.138 13.4924 30.5528 17.2332C30.0467 20.3741 28.4651 23.4362 26.2034 25.6775C21.4111 30.3968 13.6454 32.133 7.6827 28.5659C1.72003 24.9988 0.0593387 16.8859 2.95369 10.9354C4.40877 7.9523 6.73374 5.36376 9.65971 3.7696C12.7755 2.06495 16.6346 1.03901 20.1616 1.90711C26.2824 3.42236 30.5528 9.84635 31.4701 15.7811C31.6283 16.7754 33.1466 16.3493 32.9885 15.3549V15.3865Z"
        fill={color}
      />
    </svg>
  );
}
